import '@angular/compiler';
import { ComponentNavSidebarComponent } from './component.nav.sidebar/component.nav.sidebar.component';
import { PortalSeasonPaginationComponent } from './portal.season.pagination/portal.season.pagination.component';
import { PageChatbotComponent } from './page.chatbot/page.chatbot.component';
import { PortalPostListComponent } from './portal.post.list/portal.post.list.component';
import { PageChatbotRoomComponent } from './page.chatbot.room/page.chatbot.room.component';
import { PageAdminQuotasComponent } from './page.admin.quotas/page.admin.quotas.component';
import { PageDriveComponent } from './page.drive/page.drive.component';
import { PageAccessComponent } from './page.access/page.access.component';
import { PageAdminSettingsComponent } from './page.admin.settings/page.admin.settings.component';
import { PortalSeasonLoadingSeasonComponent } from './portal.season.loading.season/portal.season.loading.season.component';
import { PortalSeasonFormDropdownComponent } from './portal.season.form.dropdown/portal.season.form.dropdown.component';
import { PortalPostDetailComponent } from './portal.post.detail/portal.post.detail.component';
import { PageAdminInstructionsComponent } from './page.admin.instructions/page.admin.instructions.component';
import { LayoutEmptyComponent } from './layout.empty/layout.empty.component';
import { PortalSeasonTreeComponent } from './portal.season.tree/portal.season.tree.component';
import { LayoutSidebarComponent } from './layout.sidebar/layout.sidebar.component';
import { PortalSeasonModalComponent } from './portal.season.modal/portal.season.modal.component';
import { PortalSeasonLoadingDefaultComponent } from './portal.season.loading.default/portal.season.loading.default.component';

const INDEX_PAGE = "chatbot";

import { URLPattern } from "urlpattern-polyfill";
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

let app_routes: Routes = [
    {
        component: LayoutSidebarComponent,
        "children": [
            {
                "path": "chatbot",
                component: PageChatbotComponent,
                "app_id": "page.chatbot"
            },
            {
                "path": "chatbot/room/:id",
                component: PageChatbotRoomComponent,
                "app_id": "page.chatbot.room"
            },
            {
                "path": "admin/quotas",
                component: PageAdminQuotasComponent,
                "app_id": "page.admin.quotas"
            },
            {
                "path": "drive",
                component: PageDriveComponent,
                "app_id": "page.drive"
            },
            {
                "path": "admin/settings",
                component: PageAdminSettingsComponent,
                "app_id": "page.admin.settings"
            },
            {
                "path": "admin/instructions",
                component: PageAdminInstructionsComponent,
                "app_id": "page.admin.instructions"
            }
        ]
    },
    {
        component: LayoutEmptyComponent,
        "children": [
            {
                "path": "access",
                component: PageAccessComponent,
                "app_id": "page.access"
            }
        ]
    }
];

export class RouteInfo {
    public path: any = "";
    public segment: any = {};

    constructor() { }
}

window.WizRoute = new RouteInfo();

let patternMatcher = (pattern: any, url: any) => {
    let urlpath = url.map((x: any) => x.path).join("/");
    let testurl = 'http://test/';
    pattern = '/' + pattern;
    urlpath = testurl + urlpath;
    pattern = new URLPattern({ pathname: pattern });
    pattern = pattern.exec(urlpath)
    if (pattern && pattern.pathname) {
        let posParams = {};
        for (let key in pattern.pathname.groups) {
            if (pattern.pathname.groups[key]) {
                posParams[key] = pattern.pathname.groups[key];
            }
        }
        window.WizRoute.path = url.map((x: any) => x.path).join("/");
        window.WizRoute.segment = posParams;

        return { consumed: url, posParams: posParams };
    }
    return null
}

let routes: Routes = [{
    matcher: (url: any) => {
        for (let i = 0; i < app_routes.length; i++) {
            let layout = app_routes[i];
            let layout_childs = layout.children;
            for (let j = 0; j < layout_childs.length; j++) {
                let child = layout_childs[j];
                let matcher = patternMatcher(child.path, url);
                if (matcher)
                    return null;
            }
        }
        return { consumed: url, posParams: {} };
    },
    redirectTo: INDEX_PAGE
}];

for (let i = 0; i < app_routes.length; i++) {
    let layout = app_routes[i];
    let layout_component = layout.component;
    let layout_childs = layout.children;

    let router: any = {
        path: '',
        component: layout_component,
        children: []
    };

    for (let j = 0; j < layout_childs.length; j++) {
        let child = layout_childs[j];
        router.children.push({
            matcher: (url: any) => {
                let matcher = patternMatcher(child.path, url);
                if (matcher) return matcher;
                return null;
            },
            component: child.component
        });
    }
    routes.push(router);
}

@NgModule({ imports: [RouterModule.forRoot(routes)], exports: [RouterModule] })
export class AppRoutingModule { }